import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

export class IncreaseDownCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private lastGamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND IncreaseDownCommand', this.lastGamePlay.down + 1)
    this.gamePlay.down = this.lastGamePlay.down + 1
  }
}
